
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/daily_holoscope",
      function () {
        return require("private-next-pages/daily_holoscope/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/daily_holoscope"])
      });
    }
  